import { render } from "./RemoteDataSubTab.vue?vue&type=template&id=4324a66e&scoped=true"
import script from "./RemoteDataSubTab.vue?vue&type=script&lang=js"
export * from "./RemoteDataSubTab.vue?vue&type=script&lang=js"

import "./RemoteDataSubTab.vue?vue&type=style&index=0&id=4324a66e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4324a66e"]])

export default __exports__